module.exports = __webpack_public_path__ + "media/images/questions-e706d3f9d919fbb2eb2cca2457faacfe.svg";